/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */
(function(){
  var form = document.querySelector('.ProductForm');
  if(!form) return;

  var productData = JSON.parse(document.querySelector('[data-product-json]').textContent);
  var variants = productData.product.variants;
  var idInput = form.querySelector('select[name="id"], input[name="id"]');

  form.addEventListener('click', function(e){
    var chip = e.target.closest('.ProductForm__Chip');
    if(!chip) return;

    var pos = chip.dataset.optionPosition;
    var val = chip.dataset.value;

    // Update UI
    form.querySelectorAll('.ProductForm__Chip[data-option-position="'+pos+'"]').forEach(function(c){
      c.classList.toggle('is-selected', c === chip);
    });

    // Update label
    var label = chip.closest('.ProductForm__Option').querySelector('.ProductForm__SelectedValue');
    if(label) label.textContent = val;

    // Get all selected options
    var selected = [];
    form.querySelectorAll('.ProductForm__Chips').forEach(function(group){
      var s = group.querySelector('.ProductForm__Chip.is-selected');
      if(s) selected.push(s.dataset.value);
    });

    // Match variant
    var match = variants.find(function(v){
      return [v.option1, v.option2, v.option3].filter(Boolean).every(function(o, i){
        return o === selected[i];
      });
    });

    if(match && idInput){
      idInput.value = match.id;
      idInput.dispatchEvent(new Event('change', {bubbles:true}));
    }
  });
})();